import { breakpointsInPx } from "lib/checkViewport";
import React from "react";
import { RecommendationModule } from "../RecommendationModule";
import { atbConfirmationRecommendationsWrapper } from "./ATBConfirmationRecommendations.css";
import { useProductRecommendationFragment } from "../hooks/useRecommendations";

export const RECOMMENDATION_CAROUSEL_ID =
  "RecommendationSection:add-to-bag-confirmation";

export const ATBConfirmationRecommendations: React.FC = () => {
  const recommendation = useProductRecommendationFragment(
    RECOMMENDATION_CAROUSEL_ID
  );

  if (!recommendation || recommendation.variants.length === 0) {
    return <></>;
  }

  return (
    <div className={atbConfirmationRecommendationsWrapper}>
      <RecommendationModule
        {...recommendation}
        carouselPropsOverride={{
          showNavigation: false,
          scrollbar: true,
          breakpoints: {
            [breakpointsInPx.xs]: {
              slidesPerView: 2,
              slidesPerGroup: 2
            }
          }
        }}
      />
    </div>
  );
};
